import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-362600be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lk-heading" }, "Личный кабинет", -1))
const _hoisted_2 = { class: "form-container" }

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";
import UsersViewForm from "@/entities/auth/forms/UsersViewForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalAccountPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(TopPanel, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(UsersViewForm)
      ])
    ]),
    _: 1
  }))
}
}

})